import React from 'react';
import { css } from 'linaria';
import { ModalContent, ModalHeader, Typography } from 'common/components';

const benefitsList = css`
  padding-left: 18px;
  margin: 0;

  li:not(:last-child) {
    margin-bottom: 8px;

    @media (--only-mobile) {
      margin-bottom: 4px;
    }
  }
`;

export const ReadyProject = () => (
  <>
    <ModalHeader title="Готовые окна точно в срок" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Оставьте заявку&nbsp;&mdash; и&nbsp;уже через несколько дней* у&nbsp;вас будут новые окна.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        Всё просто:
      </Typography>
      <ul className={benefitsList}>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            мы сделаем точный замер
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            подготовим расчет стоимости учитывая ваши пожелания и бюджет
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            бережно доставим и установим окна в удобное для вас время.
          </Typography>
        </li>
      </ul>
      <Typography adaptive={false} variant="m" size="body_long">
        *Сроки могут отличаться в зависимости от региона и комплектации окна.
      </Typography>
    </ModalContent>
  </>
);
